module.exports = __webpack_public_path__ + "928538b5da4f7820c7eaffbf1580a3e8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-boot-s.png
// module id = 2712
// module chunks = 0